import React from 'react';
import classNames from 'classnames';
import { Box } from '@wix/design-system';
import s from '../FeatureRow.scss';
export const FeatureRowCell = ({ children, align = 'center', dataHook, className, isPreSelected, }) => {
    return (React.createElement(Box, { className: classNames(s.featureCell, className, {
            [s.preselected]: isPreSelected,
        }), dataHook: dataHook, verticalAlign: "middle", align: align, overflow: "hidden", flexWrap: "wrap" }, children));
};
//# sourceMappingURL=FeatureRowCell.js.map